//@flow
import { fetchQuery, graphql } from 'react-relay';
import getter from 'dibs-object-getter';
import { logError } from '../../helpers';

import { getEnvironment } from '../../relayModernEnvironment';

const environment = getEnvironment();

export function userLookup(userId: string) {
    if (!userId) {
        return Promise.resolve({});
    }

    return fetchQuery(
        environment,
        graphql`
            query userLookupQuery($userId: String!) {
                viewer {
                    user(userId: $userId) {
                        profile {
                            email
                            firstName
                            lastName
                        }
                    }
                }
            }
        `,
        { userId }
    )
        .then(
            response =>
                getter(response)
                    .at('viewer')
                    .at('user')
                    .value('profile') || {}
        )
        .catch(e => {
            logError(e);
            return {};
        });
}
